import { Component, ElementRef, ViewChild } from '@angular/core';
import { BreadcrumbComponent } from '../../Common/Components/breadcrumb/breadcrumb.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectComponent, NzSelectModule } from 'ng-zorro-antd/select';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { DataGridComponent } from '../../Common/Components/data-grid/data-grid.component';
import { ApiService } from '../../Services/api.service';
import { NzInputModule } from 'ng-zorro-antd/input';
import { ConfirmPopupComponent } from '../../Common/Components/confirm-popup/confirm-popup.component';
import { debounceTime, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-fedex-orgcode-mapping',
  standalone: true,
  imports: [ConfirmPopupComponent, NzButtonModule, NzSelectModule, CommonModule, NzInputModule, FormsModule, ReactiveFormsModule, NzIconModule, DataGridComponent],
  templateUrl: './fedex-orgcode-mapping.component.html',
  styleUrl: './fedex-orgcode-mapping.component.scss'
})
export class FedexOrgcodeMappingComponent {
  constructor(private apiService: ApiService) {

  }

  orgCode: string[] = [];
  location: string = '';
  showModal: boolean = false;
  fedexColumns: any = [{
    field: 'uniqueId',
    header: '',
    type: "checkbox"
  },
  {
    field: 'orgCode',
    header: 'Organization Code',
    editable: true,
    compare: (a: any, b: any) => (a.orgCode ?? "").localeCompare((b.orgCode ?? ""))
  },
  {
    field: 'locationCode',
    header: 'Location Code',
    editable: true,
    compare: (a: any, b: any) => (a.locationCode ?? "").localeCompare((b.locationCode ?? ""))
  },
  {
    field: '',
    header: 'Action',
    icons: ['edit', 'delete'],
    type: 'icon',
    showIcons: true
  }];
  fedexOrgCodeList: any = [];
  selectedList: any = [];
  inValidForm: boolean = false;
  searchText: string = '';
  payLoadData: any = [];
  @ViewChild(DataGridComponent) private dataGridComponent!: DataGridComponent;
  originalFedexArrData: any[] = [];
  pageSize: number = 50;
  private scrollSubject = new Subject<void>();
  private scrollSubscription!: Subscription;
  @ViewChild('multiSelectRef', { read: ElementRef }) selectElement!: ElementRef;
  @ViewChild('multiSelectRef') multiSelectRef!: NzSelectComponent;
  currentSearchValue:string = '';

  ngOnInit() {
    this.getFedexOrgCodeList();
    this.scrollSubscription = this.scrollSubject
      .pipe(debounceTime(200))
      .subscribe(() => {
        this.loadNextBatch
          ();
      });

  }

  getFedexOrgCodeList() {

    this.apiService.getFedexOrgCodeList().subscribe(res => {
      this.originalFedexArrData = res;
      this.originalFedexArrData = this.originalFedexArrData instanceof Array ? this.originalFedexArrData : [];
      this.originalFedexArrData.map((node: any) => Object.assign(node, {uniqueId: node.orgCode + "_" + node.locationCode, oldOrgCode: node.orgCode, oldLocationCode: node.locationCode }))
      if (this.originalFedexArrData.length > 0) {
        this.fedexOrgCodeList = this.originalFedexArrData.slice(0, this.pageSize);
      }
    })

  }

  onSearch(value: string): void {
   
    const sanitizedValue = value.replace(/[^a-zA-Z0-9 ,]/g, '');


    if (value !== sanitizedValue) {
      this.setNativeInputValue(sanitizedValue);
    }
  }



 getNativeInput(): HTMLInputElement | null {
    if (!this.selectElement) return null;
    return this.selectElement.nativeElement.querySelector('input.ant-select-selection-search-input');
  }
  setNativeInputValue(value: string): void {
    if (!this.selectElement) return;

   
    const inputEl = this.selectElement.nativeElement.querySelector('input.ant-select-selection-search-input');
    if (inputEl) {
      inputEl.value = value;
     
      inputEl.dispatchEvent(new Event('input'));
    }
  }

  loadNextBatch() {
    if (this.fedexOrgCodeList.length < this.originalFedexArrData.length) {
      const nextBatch = this.originalFedexArrData.slice(
        this.fedexOrgCodeList.length,
        this.fedexOrgCodeList.length + this.pageSize
      );
      this.fedexOrgCodeList = [...this.fedexOrgCodeList, ...nextBatch];
    }
  }

  selectedRow(data: any) {
    this.selectedList = [...data];
  }

  onPaste(event: ClipboardEvent): void {

    event.preventDefault();
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData ? clipboardData.getData('text') : '';

    if (!pastedText) return;

    const cleanedTags = pastedText
      .replace(/\s+/g, '')
      .split(',')
      .filter((tag: any) => tag.length > 0);

    this.orgCode = Array.from(new Set([...this.orgCode, ...cleanedTags]));

    this.orgCode = [...this.orgCode];
  }

  deleteSelected() {
    let postObj: any = [];
    this.selectedList.map((node: any) => {
      this.originalFedexArrData.map((node2: any) => {
        if (node === node2.uniqueId) {
          postObj.push({
            "orgCode": node2.orgCode,
            "locationCode": node2.locationCode,
            "oldOrgCode": "",
            "oldLocationCode": "",
            "updateType": "DELETE"
          })
        }

      })
    });
    this.payLoadData = postObj;
    this.showModal = true;
  }

  updateFedexList(data: any) {
    this.apiService.updateFedexOrgCodeList(data).subscribe(res => {
      this.apiService.createNotification('success', res?.message);
      this.ngOnInit();
      this.orgCode = [];
      this.location = '';
      this.payLoadData = [];
      this.searchText = '';
      this.showModal = false;
    }, err => {
      this.apiService.createNotification('error', err?.error?.message);
    })
  }

  searchOrgCode(searchValue: string) {
    this.dataGridComponent.searchData(searchValue, ['orgCode', 'locationCode'], this.originalFedexArrData);
  }


  deleteFedexMapping(data: any) {
    let postObj = {
      "orgCode": data.orgCode,
      "locationCode": data.locationCode,
      "oldOrgCode": "",
      "oldLocationCode": "",
      "updateType": "DELETE"
    }

    this.updateFedexList([postObj]);
  }

  addFedexOrgCode() {
    if (this.orgCode.length == 0 || !this.location) {
      this.inValidForm = true;
      return
    }
    this.inValidForm = false;
    let postObj: any = [];
    this.orgCode.map((node: any) => {
      postObj.push({
        "orgCode": node,
        "locationCode": this.location,
        "oldOrgCode": "",
        "oldLocationCode": "",
        "updateType": "ADD"
      })
    });

    this.updateFedexList(postObj);
  }

  editRow(data: any) {
    let postObj = {
      "orgCode": data.orgCode,
      "locationCode": data.locationCode,
      "oldOrgCode": data.oldOrgCode,
      "oldLocationCode": data.oldLocationCode,
      "updateType": "UPDATE"
    };
    this.updateFedexList([postObj]);
  }

  closeSelect(selectComponent: NzSelectComponent) {
    selectComponent.nzOpen = false;
  }

  ngOnDestroy() {
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
    }
  }

  onTableScroll(event: any) {
    const element = event.target;
    const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 50;

    if (atBottom) {
      this.scrollSubject.next(); // Push to the subject
    }
  }

}
